"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const user_context_1 = require("../../../context/user-context");
const material_1 = require("@mui/material");
const avatar_renderer_1 = require("../../../component/avatar/avatar-renderer");
exports.UserInfoLayout = (0, react_1.memo)(() => {
    const { userMeta } = (0, user_context_1.useUserMeta)();
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", alignItems: "center", width: "100%", spacing: 2, children: [(0, jsx_runtime_1.jsx)(avatar_renderer_1.AvatarRenderer, { avatar: userMeta.avatar, sx: {
                    width: theme.spacing(10),
                    height: theme.spacing(10),
                } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", noWrap: true, color: theme.palette.primary.contrastText, children: userMeta.nickname })] }));
});
exports.UserInfoLayout.displayName = "UserInfoLayout";
